export const getBannedCountriesFilter = () => {
  try {
    return (
      JSON.parse(process.env.REACT_APP_BANNED_COUNTRIES)
        ?.map((e) => `(NOT country_name:"${e}")`)
        .join(" AND ") || ""
    );
  } catch (err) {
    return "";
  }
};
